module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAMAAABhEH5lAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABIUExURUdwTP///////////////////////////////////////////////////////////////////////////////////////////wV68vgAAAAXdFJOUwA7WnIWy4PvEfmTQSTSBTGp3Um23iezSiCHuQAAAG5JREFUGNNl0EcWgCAMBNDQBXvN/W8qsTKa5X+BGaDOR9cQjGfmYIFCJm7/xFVJTiQCGSEPB6uYSWGkrA1Ix23Ygqw0+6ypf1uapIfOUenNqaXJ6HL40oAdE9bb+sfSW3m+yBQh+vwUeG6n0+Yt7QEtCIZLMs6gAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/header/tel-white.png
// module id = Es9Y
// module chunks = 0